<template>
  <Form
    ref="details"
    :model="fromData"
    :rules="ruleValidate"
    label-position="right"
    :label-width="120"
  >
    <Row span="24">
      <Col span="10">
        <FormItem :label="$t('add.village.443671-0')" prop="Zname">
          <Input v-model="fromData.Zname" :placeholder="$t('add.village.443671-1')"></Input>
        </FormItem>
      </Col>
      <Col span="10">
        <FormItem :label="$t('add.village.443671-2')">
          <div class="ivu-form-item-content">
            <div
              class="ivu-input-wrapper ivu-input-wrapper-default ivu-input-type-text"
            >
              <input
                ref="input"
                type="text"
                id="suggestId"
                name="address_detail"
                :placeholder="$t('add.village.443671-3')"
                v-show="!address_detail"
                class="input_style ivu-input ivu-input-default"
              />
              <input
                type="text"
                v-show="address_detail"
                v-model="address_detail"
                @click="addressDetailClick()"
                class="input_style ivu-input ivu-input-default"
              />
              <div id="allmap1" style="width: 0px; height: 0px;"></div>
            </div>
          </div>
        </FormItem>
      </Col>
      <Col span="10">
        <FormItem :label="$t('add.village.443671-4')" prop="Jd">
          <Input v-model="fromData.Jd" :placeholder="$t('add.village.443671-4')"></Input>
        </FormItem>
      </Col>
      <Col span="10">
        <FormItem :label="$t('add.village.443671-5')" prop="Wd">
          <Input v-model="fromData.Wd" :placeholder="$t('add.village.443671-5')"></Input>
        </FormItem>
      </Col>
    </Row>
  </Form>
</template>

<script>
export default {
    props: {
        areas: {
            type: Object,
            default: () => {}
        }
    },
  data() {
    return {
      address_detail: null, //详细地址
      userlocation: {
        lng: "",
        lat: ""
      },
      addressText: "",
      fromData: {
        Zname: "",
        Zaddress: "",
        Jd: "",
        Wd: ""
      },
      ruleValidate: {
        Zname: [{ required: true, message: this.$t('add.village.443671-6'), trigger: "blur" }],
        Jd: [{ required: true, message: this.$t('add.village.443671-7'), trigger: "blur" }],
        Wd: [{ required: true, message: this.$t('add.village.443671-8'), trigger: "blur" }]
      }
    };
  },
  mounted() {
    this.$nextTick(function() {
      this.initAllmap();
    });
  },
  methods: {
    // 加载区域检索地图数据
    initAllmap() {
      var th = this;
      // 创建Map实例
      var map = new BMap.Map("allmap1");
      // 初始化地图,设置中心点坐标，
      var point = new BMap.Point(121.160724, 31.173277);
      // 创建点坐标，汉得公司的经纬度坐标
      map.centerAndZoom(point, 15);
      map.enableScrollWheelZoom();

      //建立一个自动完成的对象
      var ac = new BMap.Autocomplete({
        input: "suggestId",
        location: map
      });

      var myValue;
      //鼠标点击下拉列表后的事件
      ac.addEventListener("onconfirm", function(e) {
        var _value = e.item.value;
        myValue =
          _value.province +
          _value.city +
          _value.district +
          _value.street +
          _value.business;
        this.address_detail = myValue;
        setPlace();
      });

      function setPlace() {
        //清除地图上所有覆盖物
        map.clearOverlays();

        function myFun() {
          //获取第一个智能搜索的结果
          th.userlocation = local.getResults().getPoi(0).point;
          th.fromData.Jd = th.userlocation.lng;
          th.fromData.Wd = th.userlocation.lat;
          th.addressText = local.getResults().getPoi(0).title;
          th.fromData.Zaddress = th.addressText;
          map.centerAndZoom(new BMap.Point(120.58,28.08), 18);
          //添加标注
          map.addOverlay(new BMap.Marker(th.userlocation));
        }

        //智能搜索
        var local = new BMap.LocalSearch(map, {
          onSearchComplete: myFun
        });
        local.search(myValue);
      }
    },
    async submit() {
      const from = { 
        Ccode: this.areas.Ccode,
        Vcode: this.areas.Vcode,
        ProvinceCode: this.areas.ProvinceCode,
        ProvinceName: this.areas.ProvinceName,
        CityCode: this.areas.CityCode,
        CityName: this.areas.CityName,
        AreaCode: this.areas.AreaCode,
        AreaName: this.areas.AreaName,
        Address: this.areas.Address,
        CompanyCode: this.areas.CompanyCode,
        DepartmentCode: this.areas.DepartmentCode,
        GroupCode: this.areas.GroupCode,
        Saddress: this.areas.Saddress,
        Sname: this.areas.Sname,
        Scode: this.areas.Scode,
        ...this.fromData
      };
      await this.$refs.details.validate();
      return from
    },
    setData(data) {
        this.fromData = { ...data }
        this.$nextTick(() => {
            this.address_detail = this.fromData.Zaddress
        })
    },
    // 点击输入框
    addressDetailClick() {
        let _this = this;
        _this.address_detail = false;
        this.$nextTick(() => {
            document.getElementById("suggestId").focus();
        })
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/useGas/views/area/add/village.vue